// ================================================================
// styles.ts — 共用 CSS-in-JS 設計 token（對應 HTML 原型色盤）
// ================================================================

export const C = {
  // 背景層
  bg0: '#0f1419',     // page bg
  bg1: '#1a2230',     // card/panel bg
  bg2: '#243044',     // hover / row alt
  bg3: '#2c3a52',     // border / input bg

  // 文字
  t1: '#e8edf4',      // primary
  t2: '#b0bec5',      // secondary
  t3: '#8b9ab0',      // muted
  t4: '#64748b',      // very muted

  // 強調色
  blue:   '#4da3ff',
  green:  '#4caf86',
  yellow: '#f5a623',
  red:    '#f0616d',
  purple: '#9c6fff',

  // 功能性
  dlp:      '#f0616d',
  border:   '#2c3a52',
  radius:   '8px',
  radiusLg: '12px',
} as const;

export const shadow = '0 2px 12px rgba(0,0,0,0.35)';

export const badge = (color: string): React.CSSProperties => ({
  display: 'inline-block',
  background: color + '22',
  color,
  border: `1px solid ${color}44`,
  borderRadius: 4,
  padding: '2px 7px',
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.02em',
  whiteSpace: 'nowrap',
});

export const btn = (variant: 'primary' | 'ghost' | 'danger' = 'ghost'): React.CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '7px 14px',
  border: variant === 'primary' ? 'none' : `1px solid ${C.border}`,
  borderRadius: C.radius,
  background: variant === 'primary' ? C.blue : variant === 'danger' ? '#f0616d22' : 'transparent',
  color: variant === 'primary' ? '#fff' : variant === 'danger' ? C.red : C.t2,
  fontSize: 13,
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'opacity .15s',
  whiteSpace: 'nowrap',
});

// Re-export React import needed for badge return type
import type React from 'react';
